var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWishlists = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08262 9.82199C3.4701 9.29248 3.82474 8.28166 4.61455 8.23353L8.51519 7.96079C8.74086 7.94475 8.95036 7.80033 9.04712 7.57569L10.53 3.96554C10.6912 3.59648 11.0297 3.40396 11.3681 3.40396C11.7066 3.40396 12.0451 3.59648 12.2063 3.96554L13.6892 7.57569C13.7697 7.7843 13.9793 7.92866 14.2211 7.96079L18.1217 8.23353C18.9115 8.28168 19.2661 9.29249 18.6537 9.82199L15.5912 12.309C15.4139 12.4534 15.3333 12.6941 15.3816 12.9348L16.3003 16.6893C16.4293 17.2991 15.978 17.7964 15.446 17.7964C15.2848 17.7964 15.1237 17.7483 14.9786 17.652L11.6422 15.6143C11.4488 15.4859 11.1909 15.4859 10.9975 15.6143L7.69322 17.652C7.54814 17.7483 7.37086 17.7964 7.20967 17.7964C6.67774 17.7964 6.19419 17.2991 6.35537 16.6893L7.27409 12.9348C7.32247 12.7101 7.25799 12.4694 7.06453 12.325L4.08262 9.82199Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWishlists);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wishlists.6d08ac9738b28dbccde627b02a45ba88.svg";